export const roleID = "doit_cmp_role";
export const serviceAccountName = "doit-cmp";
export const doitConnectSA = `doit-connect@${process.env.REACT_APP_FIREBASE_PROJECT_ID}.iam.gserviceaccount.com`;
export const datasetRoleID = "doit_cmp_dataset_access_role";
export const datasetProjectAccessRoleID = "doit_cmp_dataset_project_access_role";
